module.exports = {
  "general.days": "jours",
  "general.day": "jour",
  "general.select-days": "Sélectionner les jours",
  "general.select-day": "Sélectionner un jour",
  "general.selected-days": "Jours sélectionnés",
  "general.selected-day": "Jour sélectionné",
  "general.continue": "Continuer",
  "general.reservation": "Réservation",
  "general.country": "Pays",
  "general.guest": "Invité",
  "general.guests": "Invités",
  "general.guests.one": "1 Invité",
  "general.guests.other": "{0} Invités",
  "general.single.beds.one": "1 Lit simple",
  "general.single.beds.other": "{0} Lits simples",
  "general.double.beds.one": "1 Lit double",
  "general.double.beds.other": "{0} Lits doubles",
  "general.interests": "Intérêts",
  "general.interests_hostz": "Informations sur l'arrivée",
  "general.interests_offgrid": "Intérêts",
  "general.payments": "Paiements",
  "general.summary": "Résumé",
  "general.summary_offgrid": "Overview",
  "general.back": "Retour",
  "general.buy": "Acheter",
  "general.go-back": "Revenir",
  "general.next": "Suivant",
  "general.next_offgrid": "Next",
  "general.confirm": "Confirmer",
  "general.cancel": "Annuler",
  "general.close": "Fermer",
  "general.save": "Sauvegarder",
  "general.stay": "Séjour",
  "general.identify-using-qr": "Identifiez-moi avec QR",
  "general.identify-using-code": "Identifiez-moi avec un code",
  "general.identify-welcome": "Bienvenue",
  "general.identify-welcome-phrase": "Veuillez procéder à la pré-enregistrement afin que nous puissions tout préparer pour votre arrivée.",
  "general.identify-welcome-phrase-offgrid": "Please complete your online check-in as soon as possible. You will receive the arrival information one day before your arrival.",

  "general.identify-screen.title": "Accédez à votre assistant numérique pour votre séjour :",
  "general.identify-screen.subtitle": "Avec votre code de réservation ou vos données si vous êtes déjà à l'hôtel",
  "general.identify-screen.subtitle-1": "Complétez les informations pour continuer",
  "general.identify-screen.button-code": "J'ai un code de réservation",
  "general.identify-screen.button-data": "Je suis déjà à l'hôtel",
  "general.identify-screen.button-identify": "Continuer",
  "general.identify-screen.button-return-code": "Retour à l'identification par code de réservation",
  "general.identify-screen.button-return-data": "Retour à l'identification par les données de réservation",
  "general.identify-screen.error-code": "Nous n'avons pas pu trouver le code de réservation indiqué, veuillez réessayer !",
  "general.identify-screen.error-data": "Nous n'avons pas pu trouver la réservation avec les données fournies, veuillez réessayer !",
  "general.identify-screen.title-hostz": "Connectez-vous maintenant et accédez au portail de vos invités:",
  "general.active": "Actif",
  "general.inactive": "Inactif",
  "general.go-to-detail": "Aller aux détails",
  "general.go_to_website": "En savoir plus",
  "general.go-to-my-stay": "Aller à mon séjour",
  "general.guidelines": "Directives",
  "general.price": "Prix",
  "general.report": "Rapport",
  "general.edit": "Modifier",
  "general.checkin_edit": "Modifier l'info de check-in",
  "general.experiences": "Expériences",
  "general.request": "Demande",
  "general.send": "Envoyer",
  "general.detail": "Détail",
  "general.no-charge": "Gratuit",
  "general.yes": "OUI",
  "general.no": "NON",
  "general.dateformat": "MM-jj-aaaa",
  "general.short-dateformat": "MM-jj",
  "general.day": "Jour",
  "general.date": "Date",
  "general.hour": "Heure",
  "general.time": "Heure",
  "general.qty": "Qté",
  "general.reserve": "Réserver",
  "general.from": "De",
  "general.to": "À",
  "general.total": "Total",
  "general.duration": "Durée",
  "general.chat": "Chat",
  "general.services": "Services",
  "general.equipment": "Équipement",
  "general.features": "Caractéristiques",
  "general.remove": "Retirer",
  "general.upload": "Télécharger",
  "general.upload-file": "Télécharger Fichier",
  "general.balance": "Solde",
  "general.checkout": "Check-out",
  "general.accept": "Accepter",
  "general.clear": "Effacer",
  "general.send_comment": "Envoyer Commentaire",
  "general.menu": "Menus",
  "general.start.checkin": "Commencer Check-in",
  "general.placeOrder": "Passer Commande",
  "general.updateOrder": "Mettre à Jour Commande",
  "general.please": "S'il vous plaît",
  "general.touch": "Veuillez toucher",
  "general.key_explanation": "Cette clé sera fournie par le concierge",
  "general.selected": "Sélectionné",
  "general.select-date": "Veuillez sélectionner le jour, l'heure et le nombre de personnes pour votre réservation",
  "general.today": "Aujourd'hui",
  "general.time-format": " h",
  "general.yesterday": "Hier",
  "general.tomorrow": "Demain",
  "general.no-schedule-available": "Désolé, aucun horaire disponible",
  "general.fields_required": "sont des champs obligatoires",
  "general.about": "À propos",
  "general.type_message": "Tapez votre message ici...",
  "general.items.qty": "Qté d'articles",
  "general.add-to-home-screen-text": "Vous pouvez ajouter cette page à votre écran d'accueil pour un accès rapide.",
  "general.add-to-home-screen-button": "Ajouter à l'écran d'accueil",
  "general.hs": "h.",
  "general.hs-abrev": ".",
  "general.min": "min",
  "general.select_option": "Choisissez une option...",
  "general.customization": "Configurez votre module Suppléments...",

  "hotel.website": "Site Web",
  "hotel.phones": "Téléphones",
  "hotel.address": "Adresse",
  "hotel.contact-us": "Contactez-nous",
  "hotel.social-networks": "Réseaux Sociaux",
  "hotel.please-feel": "N'hésitez pas à nous contacter ! Voir les informations de contact ci-dessous.",
  "hotel.location": "Emplacement",
  "hotel.conditioning-air-in-common-spaces": "Climatisation dans les espaces communs",
  "hotel.parking": "Parking",
  "hotel.free-parking": "Parking Gratuit",
  "hotel.pay-parking": "Parking Payant",
  "hotel.bar": "Bar",
  "hotel.aesthetic-center": "Centre Esthétique",
  "hotel.kids-club": "Club Enfants",
  "hotel.luggage-storage": "Consigne à bagages",
  "hotel.breakfast": "Petit Déjeuner",
  "hotel.breakfast-buffet": "Buffet Petit Déjeuner",
  "hotel.smoke-free-space": "Espace Non-fumeur",
  "hotel.fitness-center": "Centre de Fitness",
  "hotel.gay-friendly": "Gay Friendly",
  "hotel.hydromassage": "Hydromassage",
  "hotel.gardens": "Jardins",
  "hotel.masseuse-available": "Masseur Disponible",
  "hotel.water-park": "Parc Aquatique",
  "hotel.hairdressing": "Salon de Coiffure",
  "hotel.bilingual-staff-english-spanish": "Personnel Bilingue (Anglais / Espagnol)",
  "hotel.pet-friendly": "Animaux Acceptés",
  "hotel.pool": "Piscine",
  "hotel.smoking-points": "Points Fumeurs",
  "hotel.reception-24-hs": "Réception 24h",
  "hotel.restaurant": "Restaurant",
  "hotel.restaurant-to-the-card": "Restaurant à la carte",
  "hotel.theme-restaurant": "Restaurant Thématique",
  "hotel.congress-hall": "Salle de Congrès",
  "hotel.meeting-room": "Salle de Réunion",
  "hotel.sauna": "Sauna",
  "hotel.laundry-service": "Service de Blanchisserie",
  "hotel.babycare-service": "Service de Garde d'enfants",
  "hotel.spa": "Spa",
  "hotel.theater": "Théâtre",
  "hotel.terraces": "Terrasses",
  "hotel.souvenir-shop": "Boutique de Souvenirs",
  "hotel.airport-transfer": "Transfert Aéroport à la demande",
  "hotel.covid.protected-medical-area": "Zone Médicale Protégée",
  "hotel.covid.virtual-check-in-out": "Check-In / Out Virtuel",
  "hotel.covid.temperature-check": "Contrôle de Température",
  "hotel.covid.first-aid-kit-available": "Trousse de Premiers Soins Disponible",
  "hotel.covid.separation-screens-for-personnel": "Écrans de Séparation pour le Personnel",
  "hotel.covid.contactless-payment-available": "Paiement Sans Contact Disponible",
  "hotel.covid.sanitizers-in-common-areas": "Désinfectants dans les Zones Communes",
  "hotel.covid.use-of-specific-cleaning-articles-for-covid": "Utilisation de Produits de Nettoyage Spécifiques pour le Covid",
  "checkin.checkin.preparing-title": "Préparation de votre Check-in",
  "checkin.checkin.preparing-text": "Veuillez ne pas fermer ou actualiser cette fenêtre.",
  "checkin.status": "Statut de Check-in",
  "checkin.status-pending": "En Attente",
  "checkin.status-observed": "Action Requise",
  "checkin.status-to_validate": "En Cours de Traitement",

  "checkin.status-to_validate-text--": "<b>C'est tout pour le moment !</b> Nous vérifierons les informations et vous enverrons un message de confirmation sous peu ! Cordialement !",
  "checkin.status-to_validate-text": "<b>C'est tout pour le moment !</b> Merci d'avoir complété l'enregistrement en ligne. Cordialement",

  "checkin.status-in_progress": "En Cours",
  "checkin.status-accepted": "Accepté",
  "checkin.status-accepted-text": "<b>Votre Check-in a été complété avec succès !</b> Nous avons hâte de vous accueillir ! Bon voyage !",
  "checkin.status-no_show": "Non Présenté",
  "checkin.status-no_show-text": "Veuillez nous contacter via le bouton de chat ci-dessous si vous souhaitez reprogrammer votre réservation originale. Nous espérons vous voir bientôt !",
  "checkin.status-canceled": "Annulé",
  "checkin.status-canceled-text": "Votre réservation a été annulée. Veuillez nous contacter via le bouton de chat ci-dessous si vous pensez que c'est une erreur ou si vous souhaitez la modifier. Merci !",
  "checkin.status-done": "Check-out Réalisé",
  "checkin.status-done-text": "Votre séjour est terminé ! Contactez-nous via le bouton de chat ci-dessous. Merci !",
  "checkin.please-complete": "Veuillez remplir ce formulaire pour compléter le processus de check-in. Si vous avez déjà un code de check-in, entrez-le ",
  "checkin.not-forget": "N'oubliez pas d'ajouter toutes les personnes qui voyagent avec vous. Vous pourrez entrer leurs informations après avoir complété ce formulaire.",
  "checkin.initiated": "Mon Check-in",
  "checkin.stay": "Séjour",
  "checkin.in": "Date d'entrée",
  "checkin.out": "Date de sortie",
  "checkin.travel-type": "Type de Voyage",
  "checkin.inputs.select": "Sélectionner",
  "checkin.inputs.email": "Email",
  "checkin.inputs.travelType": "Type de Voyage",
  "checkin.inputs.dni-number": "Numéro",
  "checkin.inputs.dni-number-offgrid": "Numéro",
  "checkin.inputs.dni-issue-date": "Date de Délivrance",
  "checkin.inputs.dni-issue-date-offgrid": "Date de Délivrance",
  "checkin.inputs.dni-issue-date-simplex": "Date de Délivrance",
  "checkin.inputs.dniType": "Type de PIèce d'Identité",
  "checkin.inputs.zipCode": "Code Postal",
  "checkin.inputs.dni": "Numéro d'Identité",
  "checkin.inputs.dniIssueDate": "Date de Délivrance de la PIèce d'Identité",
  "checkin.inputs.dniIssueDate-offgrid": "Date de Délivrance de la PIèce d'Identité",
  "checkin.inputs.dniIssueDate-simplex": "Date de Délivrance de la PIèce d'Identité",
  "checkin.inputs.name": "Nom",
  "checkin.inputs.surname": "Prénom",
  "checkin.inputs.gender": "Genre",
  "checkin.inputs.gender.male": "Masculin",
  "checkin.inputs.gender.female": "Féminin",
  "checkin.inputs.gender.other": "Autre",
  "checkin.inputs.date-of-birth": "Date de Naissance",
  "checkin.inputs.address": "Adresse",
  "checkin.inputs.postal-code": "Code Postal",
  "checkin.inputs.nationality": "Nationalité",
  "checkin.inputs.residence": "Résidence",
  "checkin.inputs.country_of_residence": "Pays de Résidence",
  "checkin.inputs.birthday": "Date de Naissance",
  "checkin.inputs.city": "Ville",
  "checkin.inputs.phone": "Téléphone",
  "checkin.inputs.passenger": "Données du Passager",
  "checkin.inputs.photos_dniFront": "Carte Recto",
  "checkin.inputs.photos_dniBack": "Carte Verso",
  "checkin.inputs.photos_selfie": "Selfie",

  "checkin.inputs.entryTime": "Heure d'Arrivée",
  "checkin.inputs.arrivalMode": "Comment arriverez-vous?",
  "checkin.inputs.extraData_qtyAdults": "Adultes",
  "checkin.inputs.extraData_qtyChild": "Enfant",
  "checkin.inputs.extraData_qtyBabies": "Bébés",
  "checkin.company-information": "Informations de la Société",
  "checkin.company-information-text": "Veuillez fournir les informations de votre société.",
  "checkin.company-name": "Nom",
  "checkin.company-name-placeholder": "Entrez le nom",
  "checkin.company-address": "Adresse",
  "checkin.company-address-placeholder": "Entrez l'adresse",
  "checkin.company-country": "Pays",
  "checkin.company-country-placeholder": "Sélectionnez le pays",
  "checkin.company-zip-code": "Code Postal",
  "checkin.company-zip-code-placeholder": "Entrez le code postal",
  "checkin.company-city": "Ville",
  "checkin.company-city-placeholder": "Entrez la ville",
  "checkin.identificate": "Vérifier mon identité",

  "checkin.passenger": "Invité",
  "checkin.passengers": "Invités",
  "checkin.passengers-list": "Liste des Invités",
  "checkin.passengers-error-incomplete": "Veuillez compléter les informations des invités",
  "checkin.add-passenger": "Ajouter un Invité",
  "checkin.arrivalMode": "Mode d'Arrivée",
  "checkin.arrivalMode-hostz": "Comment arriverez-vous?",
  "checkin.arrivalMode-text": "Veuillez sélectionner le mode d'arrivée",
  "checkin.arrivalMode.airplane": "Avion",
  "checkin.arrivalMode.public_transportation": "Transports en commun (bus/train)",
  "checkin.arrivalMode.train": "Train",
  "checkin.arrivalMode.bus": "Bus",
  "checkin.arrivalMode.car": "Voiture",
  "checkin.arrivalMode.other": "Autre",
  "checkin.save-checkin": "Sauvegarder le Check-In",
  "checkin.save-changes": "Sauvegarder les Modifications",
  "checkin.update-info": "Mettre à Jour les Informations",
  "checkin.reservation-data": "Infos Réservation",
  "checkin.request-photos": "Assurez-vous que les photos sont nettes et lisibles. Vous pouvez recadrer et redimensionner les images après les avoir prises.",
  "checkin.reviewing": "Merci ! Nous examinons votre demande. Vous recevrez une notification concernant <b>l'état de votre check-in</b> sous peu.",
  "checkin.remember-can": "Rappelez-vous que vous pouvez toujours modifier vos informations de check-in.",
  "checkin.can-see": "Vous pouvez consulter l'historique de check-in et ajouter un commentaire ci-dessous.",
  "checkin.please-read-to-change": "Veuillez lire les informations ci-dessous et apporter les modifications nécessaires pour procéder.",
  "checkin.modify": "Modifier",
  "checkin.edit-data": "Éditer les Données",
  "checkin.accept": "Accepter",
  "checkin.dni-front": "Carte Recto",
  "checkin.dni-back": "Carte Verso",
  "checkin.camera": "Caméra",
  "checkin.date-of-birth": "Date de Naissance",
  "checkin.age": "Âge",
  "checkin.add-comment": "Ajouter un Commentaire",
  "checkin.me": "Moi",
  "checkin.accepted-text": "<b>Votre Check-In a été accepté !</b> Nous avons hâte de vous voir ! N'oubliez pas que vous pouvez nous poser des questions dans la section des commentaires ci-dessous. Bon voyage !",
  "checkin.canceled-text": "<b>Votre Check-In a été annulé.</b> Veuillez lire les commentaires ci-dessous pour savoir comment procéder. Merci !",
  "checkin.new-checkin": "Nouveau Check-In",
  "checkin.use-button-to-add-guest": "Utilisez le bouton ci-dessous pour ajouter d'autres invités.",
  "checkin.identified": "Check-In Identifié !",
  "checkin.identify-error": "Nous n'avons pas pu trouver le code de réservation indiqué, veuillez réessayer !",
  "checkin.time-of-arrival": "Heure d'Arrivée",
  "checkin.time-of-arrival-text": "Si vous avez déjà une heure d'arrivée estimée, faites-le nous savoir ici.",
  "checkin.time-of-arrival-text2": "Rappelez-vous que notre heure de check-in garantie est à {0}h.",
  "checkin.time-of-arrival-text2-hostz": "The normal check-in time is at {0}h.",
  "checkin.time-of-arrival-text2-offgrid": "Votre chambre est prête à {0}h.",
  "checkin.time-of-arrival-early-checkin": "Demande de <b>Check-In Anticipé</b> <span class='text-muted'>(sous réserve de disponibilité)</span>",
  "checkin.e-mail": "E-mail",
  "checkin.phone": "Téléphone",
  "checkin.guest-data": "Données de l'Invité",
  "checkin.guest-data-text": "Veuillez compléter les informations manquantes pour compléter votre processus de check-in en ligne.",
  "checkin.guest-complete-later": "Compléter ces informations plus tard.",
  "checkin.id-type.id": "Identité",
  "checkin.id-type.passport": "PASSEPORT",
  "checkin.id-type.nif": "NIF",
  "checkin.id-type.nie": "NIE",
  "checkin.type-of-travel": "Type de Voyage",
  "checkin.type-of-travel-text": "Nous personnaliserons votre expérience selon vos préférences et besoins.",
  "checkin.travel-type.couple": "Couple",
  "checkin.travel-type.congress": "Congrès",
  "checkin.travel-type.family": "Voyage en Famille",
  "checkin.travel-type.business": "Affaires",
  "checkin.travel-type.event": "Événement",
  "checkin.travel-type.friends": "Voyage entre Amis",
  "checkin.travel-type.relaxing": "Détente",
  "checkin.travel-type.party": "Voyage Festif",
  "checkin.travel-type.single_traveler": "Voyageur Seul",
  "checkin.travel-type.leisure": "Voyage d’agrément",
  "checkin.room-preferences": "Préférences de Chambre",

  "checkin.room-preferences-text": "Avez-vous des préférences pour votre chambre ? <br />Faites-le nous savoir ici :",
  "checkin.room-preferences.close-to-elevator": "Proche de l'ascenseur",
  "checkin.room-preferences.far-from-elevator": "Éloigné de l'ascenseur",
  "checkin.room-preferences.wheelchair-accessible": "Accessible en fauteuil roulant",
  "checkin.room-preferences.lower-floor": "Chambre au rez-de-chaussée",
  "checkin.room-preferences.higher-floor": "Chambre à l'étage supérieur",
  "checkin.take-care-environment": "Voulez-vous aider à prendre soin de l'environnement ?",
  "checkin.take-care-environment-text": "De petits gestes peuvent réduire considérablement votre empreinte écologique pendant votre séjour.",
  "checkin.take-care-environment.housekeeping-frequency": "Fréquence du ménage",
  "checkin.take-care-environment.housekeeping-frequency.everyday": "Tous les jours",
  "checkin.take-care-environment.housekeeping-frequency.every-other-day": "Un jour sur deux",
  "checkin.take-care-environment.housekeeping-frequency.do-not-clean-my-room": "Ne pas nettoyer ma chambre",
  "checkin.take-care-environment.towell-replacement-frequency": "Fréquence de remplacement des serviettes",
  "checkin.take-care-environment.towell-replacement-frequency.do-not-change": "Ne pas changer les serviettes",
  "checkin.take-care-environment.towell-replacement-frequency.everyday": "Tous les jours",
  "checkin.take-care-environment.towell-replacement-frequency.every-other-day": "Un jour sur deux",
  "checkin.restaurant-reservation": "Je suis intéressé par une réservation dans votre/vos <b>restaurant(s)</b>",
  "checkin.comments": "Commentaires",
  "checkin.comments-text": "Faites-nous savoir s'il y a quelque chose que nous pouvons faire pour améliorer votre séjour chez nous.",
  "checkin.review-the-summary": "Veuillez revoir le résumé de votre Check-in en ligne. Vous pouvez revenir en arrière et modifier les informations que vous avez fournies. Si tout est correct, appuyez sur le bouton <b>\"Confirmer\"</b> ci-dessous.",
  "checkin.reservation-code": "Code de réservation",
  "checkin.in-out": "Entrée / Sortie",
  "checkin.primary-guest": "Invité principal",
  "checkin.guests-text": "Nous avons besoin de ces informations pour déterminer la meilleure configuration des lits pour votre séjour et assurer votre confort.<br /><br /><small>Adulte (15+ ans) / Enfant (3-14 ans) / Bébé (0-2 ans)</small>",
  "checkin.adult-s": "Adulte(s)",
  "checkin.adults": "Adultes",
  "checkin.adult": "Adulte",
  "checkin.short-room": "Chambre",
  "checkin.room": "Chambre",
  "checkin.select-door-open": "Veuillez sélectionner quelle porte vous souhaitez ouvrir...",
  "checkin.select-door-open-hostz": "Cliquez sur la porte que vous souhaitez ouvrir",
  "checkin.select-door-open-themyde": "Sélectionnez une porte ci-dessous et faites glisser pour l’ouvrir.",
  "checkin.select-photo-source-to": "Sélectionnez la source de la photo pour ",
  "checkin.use-camera": "Utiliser la caméra",
  "checkin.click-edit-data-text1": " pour effectuer les modifications nécessaires. Une fois les modifications effectuées, appuyez sur ",
  "checkin.click-edit-data-text2": " puis sur ",
  "checkin.click-edit-data-text3": ". Merci pour votre collaboration !",
  "checkin.do-not-disturb": "Ne pas déranger",
  "checkin.floor-selection": "Problèmes de mobilité ?",
  "checkin.floor-selection-text": "Veuillez sélectionner l'étage où vous souhaitez vous enregistrer. Veuillez noter que nous n'avons pas d'ascenseurs.",
  "checkin.ground-floor": "J'ai des problèmes de mobilité et j'ai besoin du moins de marches possible",
  "checkin.first-floor": "Premier étage",
  "checkin.indifferent": "Indifférent",
  "checkin.entry-time-not-know-yet": "Je ne sais pas encore",
  "checkout.loading-information": "Veuillez patienter pendant que je rassemble toutes les informations nécessaires.",
  "checkout.errors-title": "Impossible de traiter votre Check-out",
  "checkout.error-balance": "Votre solde est de {0}. Veuillez régler votre compte pour pouvoir continuer.",
  "checkout.error-departure": "Votre date de Check-out est le {0}. Souhaitez-vous raccourcir votre séjour ?",
  "checkout.button": "Continuer avec le Check-out",
  "checkout.error-departure-button": "Besoin d'aide ? Discutez avec nous !",
  "checkout.error-noShowBalance": "Besoin d'assistance ou avez-vous des questions ? Nous sommes là pour vous aider ! Cliquez sur le bouton de chat ci-dessous pour nous contacter. Vous souhaitez annuler votre compte ? Vous pouvez facilement le faire ici aussi. N'oubliez pas, votre satisfaction est notre priorité absolue",
  "checkout.success-title": "Votre Check-out a été réussi !",
  "checkout.debt": "Nous ne pouvons pas traiter le check-out. Votre séjour présente un solde impayé de : ",
  "checkout.pay_now": "Payer maintenant",
  "checkout.ask_for_balance": "Malheureusement, nous ne pouvons pas traiter le check-out pour le moment. Veuillez discuter avec nous pour plus d'instructions.",
  "checkin.selfie.preview-title": "Selfie",
  "checkin.selfie.preview-text": "Recadrez l'image pour centrer votre visage.",
  "checkin.dniFront.preview-title": "Recto de la carte d'identité",
  "checkin.dniFront.preview-text": "Recadrez l'image pour centrer correctement votre document.",
  "checkin.dniBack.preview-title": "Verso de la carte d'identité",
  "checkin.dniBack.preview-text": "Recadrez l'image pour centrer correctement votre document.",
  "checkin.redirecting": "Redirection dans {0} secondes...",
  "checkin.camera.repeat": "Répéter",
  "checkin.camera.crop": "Recadrer",
  "checkin.camera.use-photo": "Utiliser la photo",
  "checkin.reservation-conditions-text": "La direction n'assume aucune responsabilité pour les objets de valeur laissés dans la chambre d'hôtes.<br /><br /><b>L'heure de Check-out est à 11h00.</b><br /><br /><span class='text-danger font-weight-bold'>Il est interdit de fumer dans toutes nos Chambres d'Invités et dans tous les espaces publics.</span><br />Il est seulement permis de fumer à l'extérieur du bâtiment, dans la rue. Si vous fumez néanmoins dans la chambre, nous devrons facturer des frais de nettoyage de 250,00 euros.<br /><br /><small>Les données mentionnées ci-dessus sont gérées par l'EDP.</small>",
  "checkin.reservation-conditions-text-offgrid": "<b>Check-in :</b> à partir de 15h<br/><b>Check-out :</b> jusqu'à 11h<br/><ul><li>Il est interdit de fumer dans toutes nos cabanes.</li><li>Veuillez noter que seuls les invités enregistrés sont autorisés à rester et dormir dans la cabane. Le nombre maximum d'invités est de 2 personnes.</li><li>Veuillez signaler immédiatement les dommages et défauts via “Rapport de dommages“ dans votre guide ou contactez-nous via notre hotline : +49 30 54806375.</li><li>Travel to and use of our off-grid accommodations are at your own risk; we accept no liability for weather-related restrictions, road conditions, or accidents. Detailed regulations can be found in our terms and conditions.</li></ul><br />Un aperçu des règles de la cabane se trouve dans votre guide de voyage sous “Votre cabane“ -> “Règles de la cabane“.",
  "checkin.gdpr-text1": "En signant ci-dessous, je consens au traitement de mes données personnelles conformément à la",
  "checkin.gdpr-text2": ". Je comprends que je peux retirer mon consentement à tout moment.",
  "checkin.gdpr-text-nexo": "et la",

  "checkin.gdpr-text1-costa": "By signing below, I consent to the processing of my personal data as outlined in the",
  "checkin.gdpr-text2-costa": ", and I declare that I am not a tax resident in the Argentine Republic, as per ",
  "checkin.gdpr-text-nexo-costa": ", and understand that I can withdraw my consent at any time. I also confirm that I have read and accept the ",
  "checkin.gdpr-text3-costa": "I declare that my stay in Argentina is for tourism and does not exceed the legally allowed period, in order to request a VAT refund under Law N° 3971 (AFIP) and Resolution N° 566.",
  "checkin.gdpr-button-2-popup": "I declare that my stay in Argentina does not exceed the stablished maximum term, according to the current immigration legislation and my reason to visit Argentina is for tourism only.<br />The present AFFIDAVIT serves for the purposes of issuing the VAT exemption request, due to the General Resolution N° 3971(AFIP) and Resolution N°566(tourism)",

  "checkin.gdpr-text1-hostz": "En signant ci-dessous, je consens au traitement de mes données personnelles conformément aux",
  "checkin.gdpr-text2-hostz": ".",
  "checkin.gdpr-text-nexo-hostz": " et je comprends que je peux retirer mon consentement à tout moment.<br/><br/>Je reconnais et accepte de respecter les ",

  "checkin.gdpr-text1-simplex": "En signant ci-dessous, je consens au traitement de mes données personnelles conformément aux",
  "checkin.gdpr-text2-simplex": ".",
  "checkin.gdpr-text-nexo-simplex": " et je comprends que je peux retirer mon consentement à tout moment.<br/><br/>Je reconnais et accepte de respecter les ",

  "checkin.gdpr-text1-offgrid": "En signant ci-dessous, j'accepte le traitement et l'utilisation de mes données personnelles conformément à la",
  "checkin.gdpr-text2-offgrid": " de Offgrid Mindful Cabins.",
  "checkin.gdpr-text-nexo-offgrid": " et j'accepte les ",

  "checkin.gdpr-button": "Politique de Confidentialité",
  "checkin.gdpr-button-1": "Règlements de l'Hôtel",
  "checkin.gdpr-button-1-simplex": "Règlement intérieur de l'Hôtel",
  "checkin.gdpr-button-1-hostz": "Règlement intérieur de l'Hôtel",
  "checkin.gdpr-button-1-hostz-swissstay": "Règlement intérieur",
  "checkin.gdpr-button-1-offgrid": "General Terms & Conditions",

  "checkin.terms-and-conditions": "Termes et Conditions",
  "checkin.hotel-regulations": "Règlements de l'Hôtel",
  "checkin.the_myde_selfie_message": "Veuillez télécharger un <b>selfie de vous tenant votre pièce d’identité</b> (passeport, carte d’identité ou permis de conduire). Cela nous aide à assurer la sécurité et le bon déroulement de votre séjour.",
  "checkin.terms-and-conditions-button-detail": "du séjour à l'hôtel",

  "checkin.signature": "Signature",
  "checkin.please-sign-here": "Veuillez taper ici pour signer",
  "checkin.please-sign-below": "Veuillez signer ci-dessous",
  "checkin.confirm": "Confirmer",
  "checkin.newsletter": "Newsletter",
  "checkin.newsletter-optin": "Je souhaite recevoir les actualités et offres de l'hôtel par email",
  "checkin.child": "Enfant",
  "checkin.child-s": "Enfant(s)",
  "checkin.children": "Enfants",
  "checkin.no-children": "Sans enfants",
  "checkin.babies": "Bébés",
  "checkin.years": "années",
  "checkin.no.name.yet": "Nom non fourni pour le moment.",
  "checkin.dniFront.required": "Le recto de la carte d'identité est requis",
  "checkin.selfie.required": "Le selfie est requis",
  "checkin.dniBack.required": "Le verso de la carte d'identité est requis",
  "checkin.the_myde_selfie_message_title": "Important!",
  "checkin.please-complete-your-checkin-title": "Check-in en attente",
  "checkin.please-complete-your-checkin-text": "Veuillez compléter votre check-in en cliquant ici.",
  "general.notifications": "Notifications",
  "general.notifications_description": "Vos paramètres personnels sur cette application pour personnaliser votre expérience.",
  "cups.title": "Suppléments",
  "cups.remove_button": "Retirer",
  "cups.add_button": "Ajouter",
  "cups.subject_to_availability": "Sous réserve de disponibilité",
  "cups.subject_to_availability_text": "Cet article est sujet à disponibilité. Durant ce processus, aucun frais ne sera engagé, et suite à votre sélection, un représentant de l'hôtel vous contactera pour vous fournir davantage de détails à ce sujet.",
  "cups.preferedList_text": "Basé sur vos intérêts, nous avons ces expériences pour vous",
  "cups.otherList_text": "Peut-être que ces expériences pourraient également vous intéresser",
  "cups.tags.best-selling": "Meilleure Vente",
  "cups.tags.most-popular": "Le Plus Populaire",
  "cups.tags.best-price": "Meilleur Prix",
  "cups.priceIsPerNight": "par nuit",
  "cups.confirm": "Confirmer cet achat ?",
  "cups.booked": "Réservé",
  "cups.spots": "places",
  "date.january": "Janvier",
  "date.february": "Février",
  "date.march": "Mars",
  "date.april": "Avril",
  "date.may": "Mai",
  "date.june": "Juin",
  "date.july": "Juillet",
  "date.august": "Août",
  "date.september": "Septembre",
  "date.october": "Octobre",
  "date.november": "Novembre",
  "date.december": "Décembre",

  "maps.how_to_reach_us": "Comment nous rejoindre ?",
  "maps.get_directions": "Obtenir les directions",

  "room-categories.air-conditioning": "Climatisation",
  "room-categories.complimentary-dressing": "Dressing gratuit",
  "room-categories.work-area": "Espace de travail",
  "room-categories.private-balcony": "Balcon privé",
  "room-categories.cable": "Câble",
  "room-categories.safe-box": "Coffre-fort",
  "room-categories.sommier-beds": "Lits sommier",
  "room-categories.room": "Chambre",
  "room-categories.hydromassage": "Hydromassage",
  "room-categories.coffee-machine": "Machine à café",
  "room-categories.minibar": "Minibar",
  "room-categories.hairdryer": "Sèche-cheveux",
  "room-categories.selection-of-pillows": "Sélection d'oreillers",
  "room-categories.ironing-service": "Service de repassage",
  "room-categories.smart-tv": "Smart TV",
  "room-categories.king-size-bed": "Lit king size",
  "room-categories.phone": "Téléphone",
  "room-categories.tv-lcd": "TV LCD",
  "room-categories.satellite-tv": "TV par satellite",
  "room-categories.street-view": "Vue sur la rue",
  "room-categories.garden-view": "Vue sur le jardin",
  "room-categories.sea-view": "Vue sur la mer",
  "room-categories.wifi": "Wifi",
  "room-categories.ketle": "Bouilloire électrique",
  "room-categories.fridge": "Réfrigérateur",
  "room-categories.dishwasher": "Lave-vaisselle",
  "room-categories.oven": "Four",
  "room-categories.freezer": "Congélateur",
  "room-categories.water-heater": "Chauffe-eau",
  "room-categories.plates-glasses": "Assiettes et verres",
  "room-categories.cutlery-dishes": "Couverts et vaisselle",
  "room-categories.microwave": "Micro-ondes",
  "room-categories.kettle": "Bouilloire électrique",
  "room-categories.nespresso-machine": "Machine Nespresso",

  "room-categories.toilette-with-shower-box": "Toilette de réception avec cabine de douche",
  "room-categories.sofa-bed": "Canapé-lit",
  "room-categories.partial-sea-view": "Vue partielle sur la mer",
  "room-categories.welcome-amenities": "Articles de bienvenue",
  "room-categories.shower": "Douche",
  "room-categories.bathtub": "Baignoire",
  "room-categories.double-sink": "Double vasque",
  "room-categories.connected-rooms": "Chambres communicantes",
  "room-categories.king-or-twin-beds": "Lit king ou lits jumeaux",
  "room-categories.los-troncos-view": "Vue sur le quartier Los Troncos",
  "room-categories.daily-courtesy-water": "Eau de courtoisie quotidienne",
  "room-categories.daily-courtesy-capsule-dilmah": "Capsule Dilmah de courtoisie quotidienne ou infusion",
  "room-categories.stay-courtesy-capsule-dilmah": "Capsule Dilmah de courtoisie du séjour ou infusion",

  "meeting_rooms.dvd-player": "Lecteur DVD",
  "meeting_rooms.high-speed-wi-fi": "WIFI haute vitesse",
  "meeting_rooms.independent-access": "Accès indépendant",
  "meeting_rooms.lunch-service": "Service de déjeuner",
  "meeting_rooms.meeting-room": "Salle de réunion",
  "meeting_rooms.megaphone": "Mégaphone",
  "meeting_rooms.microphone": "Microphone",
  "meeting_rooms.smart-tv": "Smart TV",
  "meeting_rooms.video-projection": "Projection vidéo",
  "meeting_rooms.capacity": "Capacité :",
  "meeting_rooms.people": "personnes.",
  "welcome.title": "Bienvenue dans notre hôtel !",
  "welcome.subtitle": "Nous vous souhaitons un agréable séjour !",
  "welcome.text": "<b>Je m'appelle ViCo et je serai votre concierge virtuel !</b> Je suis disponible 24 heures sur 24 et vous pouvez me demander n'importe quoi ! Pour ce faire, entrez dans la section 'Demande' où vous pouvez commander le service en chambre, le ménage, les fournitures de chambre, etc.",
  "welcome.text-costa-galana": "<b>Avec notre service de concierge mobile</b>, vous pouvez recevoir une attention personnalisée 24 heures sur 24 pour répondre à vos préférences, demandes et recommandations... <br /><br />Depuis le confort de votre appareil, vous pouvez demander le ménage, le service en chambre, les réservations au restaurant et au spa, entre autres. <br /><br />Cliquez sur 'Démarrer' et entrez dans la section Demande.<br /><br />Si vous le souhaitez, vous pouvez appeler l'extension 99 depuis votre chambre.",
  "welcome.text-hostz-becozy": "Bienvenue dans notre Becozy Basel, vous trouverez tout ce dont vous avez besoin pour profiter pleinement de votre séjour.<br><br>Grâce à ce portail, vous pouvez améliorer votre expérience avec nos services disponibles, explorer notre propriété, découvrir les choses à faire dans la région et bien plus encore.",
  "welcome.text-hostz-san-carlo": "Bienvenue à l'Hôtel San Carlo à Lugano, vous trouverez tout ce dont vous avez besoin pour profiter pleinement de votre séjour.<br><br>Grâce à ce portail, vous pouvez améliorer votre expérience avec nos services disponibles, explorer notre propriété, découvrir les choses à faire dans la région et bien plus encore.",
  "welcome.text-hostz-blacksummit": "Bienvenue au Black Summit Resort à Laax! Dans ce portail, vous trouverez tout ce dont vous avez besoin pour profiter pleinement de votre séjour.<br><br>Grâce à ce portail, vous pouvez améliorer votre expérience avec nos services disponibles, explorer notre propriété, découvrir les choses à faire dans la région et bien plus encore.",

  "welcome.text-hostz-betahouse": "Bienvenue! Vous êtes désormais enregistré.",
  "welcome.text-hostz-themyde": "<br/><br/><b>Bienvenue ! Vous êtes maintenant enregistré. </b>Retrouvez toutes vos informations d'accès dans la section Informations d'accès de votre tableau de bord.<br/><br/></br/>",
  "welcome.text-hostz-arosa": "<br/><br/><b>Bienvenue ! Vous êtes maintenant enregistré. </b>Retrouvez toutes vos informations d'accès dans la section Informations d'accès de votre tableau de bord.<br/><br/></br/>",
  "welcome.text-hostz-swissstay": "Bienvenue ! Vous êtes désormais enregistré. Retrouvez toutes vos instructions d'accès dans la section « Informations d'accès » de votre tableau de bord.",
  "welcome.text-hostz-steiners": "Bienvenue ! Vous êtes désormais enregistré. Retrouvez toutes vos instructions d'accès dans la section « Informations d'accès » de votre tableau de bord.",

  "welcome.subtitle-offgrid": "Bienvenue dans votre Guide du Chalet :)",
  "welcome.text-offgrid": "Vous trouverez ici tout ce dont vous avez besoin pour votre séjour – de votre <b>enregistrement en ligne</b> et vos <b>informations d'arrivée</b> à des conseils utiles pour votre temps au chalet.<br><br>Si vous avez des questions, n'hésitez pas à nous contacter à tout moment – nous sommes heureux de vous aider !<br>Pour les questions urgentes, envoyez-nous simplement un message sur <b>WhatsApp au +49 30 54806375</b>.",
  "welcome.footer-offgrid": "👉 <b>Pour un accès facile</b>, vous pouvez enregistrer le Guide du Chalet sur votre écran d'accueil. Appuyez simplement sur <b>\"accepter\"</b> et faites glisser l'icône où vous le souhaitez. Il ne prend pas de place et vous pouvez le supprimer à tout moment après votre séjour.<br><br><b>Passez un merveilleux séjour !</b> 🌿",
  "welcome.room-offgrid": "Chalet",

  "welcome.footer-hostz": "Pour un accès facile, nous vous recommandons d'activer les notifications et de créer un raccourci sur votre écran d'accueil. Cela vous permettra de rester au courant des informations importantes concernant votre séjour et de faire facilement des demandes pour rendre votre séjour encore plus confortable.",
  "welcome.footer-hostz-betahouse": "Retrouvez toutes vos instructions d'accès dans la section «Informations d'accès» de votre tableau de bord.",

  "welcome.room": "Votre numéro de chambre est :",
  "welcome.room_bs": "Votre appartement est:",
  "welcome.footer": "Pour un accès facile, veuillez me permettre de créer un raccourci sur votre écran d'accueil. Vous avez juste à cliquer sur accepter et à le glisser où vous voulez le mettre. Il ne prend pas de place et vous pouvez le supprimer dès votre départ de l'hôtel.<br /><br /><b>Ce sera un plaisir de vous assister !</b>",
  "welcome.start": "Démarrer",
  "services.type.general": "Renseignements",
  "services.type.room_service": "Service de chambre",
  "services.type.pool_service": "Service de piscine",
  "services.type.room_supplies": "Fournitures de chambre",
  "services.type.laundry": "Blanchisserie",
  "services.type.porter": "Portier",
  "services.type.tray_collection": "Collecte des plateaux",
  "services.type.pressing": "Pressing",
  "services.type.housekeeping": "Entretien ménager",
  "services.type.wakeup_call": "Réveil",
  "services.type.car_valet": "Voiturier",
  "services.type.concierge": "Concierge",
  "services.type.lost_objects": "Objets perdus",
  "services.type.breakage_report": "Rapport de casse",
  "services.type.services_booking": "Réservation de services",
  "services.type.review_tracking": "Billet de résolution pour vos retours",
  "services.type.up_selling": "Ventes additionnelles",
  "services.type.items_sales": "Produits",
  "services.housekeeping.do-not-clean-today": "Ne pas nettoyer ma chambre aujourd'hui",
  "services.housekeeping.horary": "Rappelez-vous que l'horaire pour demander le nettoyage de la chambre est de 10h à 15h. Autrement, votre chambre ne sera pas nettoyée.",
  "services.housekeeping.horary-costa-galana": "Rappelez-vous que l'horaire pour demander le nettoyage de la chambre est de 7h à 17h.",
  "services.housekeeping.do-not-change-towels": "Ne pas changer les serviettes aujourd'hui",
  "services.housekeeping.button-title": "Envoyer la demande",
  "services.donotdisturb.button-title-activate": "Activer le mode <b>NE PAS DÉRANGER</b>",
  "services.donotdisturb.button-title-disable": "Désactiver le mode <b>NE PAS DÉRANGER</b>",
  "services.donotdisturb.extra-info": "Tant que le mode <b>NE PAS DÉRANGER</b> est actif, il ne sera pas possible de nettoyer ou de répondre à vos demandes.",
  "services.do-not-change-towels": "Ne Pas Changer les Serviettes",
  "services.sent-text": "<b>Demande envoyée !</b> Dès qu'elle sera traitée, vous serez notifié, vous pouvez également la suivre depuis l'écran <b>Tableau de bord</b>.",
  "services.go-to-requests": "Aller au Tableau de bord",
  "services.go-to-home": "Aller à l'Accueil",
  "services.status.pending": "En attente",
  "services.status.observed": "Révision",
  "services.status.in_progress": "En cours",
  "services.status.in_transit": "En route",
  "services.status.accepted": "Accepté",
  "services.status.done": "Livré",
  "services.status.canceled": "Annulé",
  "services.status.reviewed": "Révisé",
  "services.status.on_hold": "En attente",
  "services.status.seated": "Installé",
  "services.status.confirmed": "Confirmé",
  "services.active-request": "{0} demande active !",
  "services.active-requests": "{0} demandes actives !",
  "select...": "Sélectionner...",
  "services.type.gift_store": "Magasin de cadeaux",
  "services.confirm-request": "Votre commande est-elle complète ?",

  "smartlocks.swipe-to-open": "GLISSEZ POUR OUVRIR",
  "smartlocks.pin-code-arosa-explanation": "Après avoir entré le code PIN, vous devez appuyer sur les boutons # ou ↵ (enter) pour confirmer.",

  "status.messages": "Nouveaux messages !",
  "status.no_messages": "Nous n'avons pas encore répondu à votre demande concernant ce sujet. Nous vous contacterons sous peu.",
  "status.more": "Plus sur votre séjour",
  "status.faqs": "Questions fréquemment posées",
  "status.faqs_description": "Toutes les informations en un seul endroit",
  "status.contact": "Contactez-nous",
  "status.contact_whatsapp": "Écris-nous un message WhatsApp",
  "status.contact_description": "Nous sommes ici pour aider !",
  "status.settings.btnDescription_facilities_arosa":"Offres exceptionnelles de nos partenaires",
  "status.checkin_alert": "Mises à jour sur votre enregistrement",
  "status.checkin_alert_offgrid": "Neuigkeiten zu deinem Check-in",
  "status.checkin_edit": "Mettre à jour les informations d'enregistrement",
  "status.checkout_description": "Enregistrez votre départ",
  "status.checkin.chat": "Messages d'enregistrement",
  "status.stay.info": "Infos Séjour",
  "status.stay_description": "Informations sur votre séjour",
  "status.checkin.chat-desc": "Messages pendant votre processus d'enregistrement",
  "status.settings": "Notifications",
  "status.settings_description": "Gérez vos paramètres",
  "status.wifi": "WiFi",
  "status.wifi_description": "Accès WiFi",
  "status.wifi_name": "Nom de réseau",
  "status.wifi_password": "Mot de passe",
  "status.wifi_no_password": "Aucun (réseau ouvert)",
  "status.garbage": "Instructions pour l'élimination des déchets",
  "status.parking_info": "Instructions de stationnement",
  "status.garbage_description": "Tout ce que vous devez savoir",
  "status.extra-bed": "Instructions lit supplémentaire",
  "status.extra-bed_description": "Découvrez comment installer votre lit supplémentaire.",
  "status.parking_info_description": "Tout ce que vous devez savoir",
  "status.access_code": "Codes d'accès",
  "status.room_access_code": "Codes d'accès à la salle",
  "status.room_keys": "Clés de la chambre",
  "status.room_keys_description": "Vous pouvez les récupérer dans les boîtes à clés situées dans le hall",
  "status.room_keys_description_becozy": "Récupérez-les dans la boîte à clés sur la porte de votre chambre",
  "status.room_keycard": "Carte-clé de la chambre",
  "status.room_keycard_description": "Il suffit de la récupérer à la réception",
  "status.apartment_keys": "Clés de l'appartement",
  "status.apartment_keys_description": "Il vous suffit de récupérer vos clés dans la boîte à clés à l'entrée principale",
  "status.access_code_one": "Code d'accès",
  "status.access_code.pin_code": "Code PIN",
  "status.access_code_hostz": "Codes d'accès aux appartements",
  "status.access_information": "Informations d'accès",
  "status.access_information_extramsg_steiners": "La réception est ouverte tous les jours entre {0} et {1} et se trouve après la porte d’entrée principale, sur la gauche",
  "status.access_information_description": "Tout ce dont vous avez besoin pour accéder à la propriété",
  "status.access_code_description": "Informations d'accès",
  "status.access_code.main_entrance": "Porte d'entrée",
  "status.access_code.main_door": "Code d'accès principal",
  "status.access_code.room_door": "Code de chambre",
  "status.access_code.ladder": "Code de l'escalier",

  "status.access_information.access_to_room_themyde": "Accès à votre appartement",
  "status.access_code.ladder_themyde": "Francés: Porte d'entrée principale / Code de l'escalier",

  "status.access_code.hostz-becozy": "At the main entrance of the hotel, you will find a keypad on the left- hand side.Enter the access code for the hotel to gain entry.<br><br>Once inside, the key to your room will be in a lockbox directly attached to your room door.To open the lockbox, enter the code and pull the small lever on the left to open the box and collect your room key.",

  "status.access_information.access_to_hotel": "Accès à l'hôtel",
  "status.access_information.accesses_swissstay": "Accès",
  "status.access_information.access_to_room": "Accès à votre chambre",

  "status.access_code.main_entrance_themyde": "PORTES ET ENTRÉES",
  "status.access_information.access_to_room_cover": "Pendant votre séjour, vous trouverez ici les instructions pour obtenir les clés d'accès",
  "status.access_information.access_to_room_cover_arosa": "Disponible à 16h",
  "status.access_information.access_to_room_cover_sigma": "Disponible à 16h",

  "status.access_information.access_to_room_description_cozy": "Récupère ta carte d'accès dans les boîtes vertes (Keynest) du hall.",
  "status.access_information.main_entrance_description_steiners": "La porte est ouverte pendant la journée. <br>Si elle est fermée, veuillez utiliser le code ci-dessous pour ouvrir la BOÎTE À CLÉS N.1 et utiliser la carte numérique à l'intérieur pour ouvrir la porte principale.",
  "status.access_information.access_to_room_description_steiners": "Prenez votre carte-clé dans les boîtes à clés vertes situées au 2ème étage.",

  "status.access_instructions": "Instructions d'accès",
  "status.access_instructions_description": "Votre procédure d'accès",
  "status.access_code.key_collection_code": "Code de récupération des clés",
  "status.access_code.key_dropoff_code": "Code de dépôt des clés",
  "status.access_code.key_dropoff": "Remise des clés",
  "status.access_code.key_dropoff_instructions": "Déposez la clé dans la boîte noire à côté de la boîte verte où vous avez récupéré vos clés.",
  "status.access_code.key_card_collection_code": "Code de récupération de la carte",
  "status.access_code.key_card_dropoff_code": "Code de dépôt de la carte",

  "status.access_information.before_checkin": "Les informations d'accès seront disponibles le jour de l'enregistrement.",
  "status.access_information.before_checkin_with_hours": "Le code de la porte principale de l'hôtel sera visible à partir de {0} le jour de l'enregistrement. Les détails de votre chambre (numéro et code de la boîte à clés) seront disponibles à partir de {1} le même jour.",
  "status.access_information.before_checkin_with_hours_themyde": "Vous pourrez voir vos informations d'accès à {0} (heure d'enregistrement)",
  "status.access_information.before_checkin_with_hours_cozy": "Les informations d'accès seront visibles le jour de l'enregistrement à {0}, uniquement si le formulaire de check-in a été complété et le paiement effectué (y compris le dépôt de garantie de {1}).",
  "status.access_information.before_checkin_with_hours_steiners": "Les informations d’accès seront visibles le jour de l’arrivée à partir de {0}, uniquement si le formulaire de check-in. Si vous venez de régler votre réservation après l’heure de check-in, veuillez patienter 3 à 5 minutes le temps que la transaction soit traitée. Une fois le paiement approuvé, les informations d’accès s’afficheront automatiquement.",
  "status.access_information.before_checkin_with_hours_no_sd": "Les informations d'accès seront visibles le jour de l'enregistrement à {0}, uniquement si le formulaire de check-in a été complété et le paiement effectué.",
  "status.access_information.before_checkin_main": "Vous êtes le bienvenu dès {0} du matin pour profiter des installations de l'hôtel. Vous pouvez également déposer vos bagages dans la consigne en attendant que votre chambre soit prête à {1}. Les détails de votre chambre seront partagés à {1}.",
  "status.access_information.before_checkin_room": "Le code de la porte principale de l'hôtel sera visible à partir de {0} le jour de l'enregistrement. Les détails de votre chambre (numéro et code de la boîte à clés) seront disponibles à partir de {1} le même jour.",
  "status.access_information.after_checkin": "Votre séjour est terminé et les informations d'accès ne sont plus disponibles. Merci d'avoir séjourné dans notre hôtel — nous espérons vous accueillir de nouveau très bientôt !",
  "status.access_information.main_entrance": "Porte principale",
  "status.access_information.main_entrance_code": "Code de la porte principale",
  "status.access_information.main_entrance_code_sigma": "Code de la porte principale & Code de la porte arrière",
  "status.access_information.main_entrance_code_swissstay": "Accès principal",
  "status.access_information.main_entrance_code_and_skiroom_code": "Code de la porte principale & Code de la salle de ski",
  "status.access_information.room_keybox_code": "Code de la boîte à clés (située à côté de la porte de votre chambre)",
  "status.access_information.room_keybox_code_arosa": "Code de la boîte à clés (La boîte à clés est située SUR LA PORTE DE VOTRE CHAMBRE)",
  "status.access_information.please_use_main_key": "Veuillez utiliser la CLÉ PRINCIPALE",
  "status.access_information.link_modal_video": "Regardez cette courte vidéo pour voir comment fonctionne le check-in",
  "status.access_information.link_modal_video_themyde": "Regardez cette courte vidéo pour voir comment fonctionne le check-in",
  "status.access_information.title_modal_video": "Comment utiliser",
  "status.access_information.room_lock_box_code": "Code du boîtier à clés",
  "status.access_information.room_lock_box_location": "Emplacement du boîtier à clés",

  "status.location": "Emplacement",
  "status.location_description": "Obtenez l'itinéraire vers la propriété.",
  "status.location_description_swissstay": "Obtenez les indications pour l'appartement ici.",

  "status.parking": "Parking",
  "status.parking_description": "Accès & Règles",

  "bookable.limit": "Réservez avant",
  "account.add-device": "Ajouter un appareil",
  "account.stay": "Séjour",
  "account.room": "Chambre",
  "account.more-info": "Plus d'infos",
  "account.guest": "Invité",
  "account.charges": "Frais",
  "account.payments": "Paiements",
  "account.accommodation": "Hébergement",
  "account.accommodation_description": "Nuitée",
  "account.citytax": "Taxe municipale",
  "account.foodandbeverages": "Nourriture et boissons",
  "account.foodandbeverages_description": "Consommation de bar, restaurant, etc.",
  "account.other": "Autres frais",
  "account.other_description": "Autres coûts du séjour",
  "account.download": "Télécharger",
  "account.invoices": "Factures",
  "account.balance": "Solde",
  "account.chat": "Si vous avez des questions concernant la facture, n'hésitez pas à nous contacter.",
  "review.rate": "Évaluer :",
  "review.rate_us": "Évaluez-nous !",
  "review.thanks": "Merci de nous avoir évalués !",
  "review.extra_rate": "Retour supplémentaire",
  "review.extra_rate_text": "Ces évaluations nous aident à améliorer notre service",
  "review.sending_response": "Envoi de la réponse…",
  "review.rate-placeholder": "Veuillez laisser votre retour ici...",
  "review.already-rated": "Merci de nous avoir évalués, votre retour est très précieux.",
  "review.already-rated-button": "Je souhaite modifier mon évaluation.",
  "review.average": "Moyenne",
  "review.general": "Général",
  "review.contact": "Veuillez partager vos coordonnées afin que nous puissions donner suite à votre évaluation.",
  "review.screen_title": "Avis",
  "review.flow_type_rating": "Notation",
  "review.flow_type_single_choice": "Choix unique",
  "review.flow_type_opinion_scale": "Échelle d'opinion",
  "review.flow_type_ranking": "Classement",
  "review.flow_type_landing": "Page d'accueil",
  "request.detail-title": "Détail de la demande",
  "request.delivery-point": "Point de livraison",
  "request.your-request": "Votre demande",
  "request.customize_next": "Personnalisez-la à l'écran suivant",
  "request.continue_customize": "Continuer & Personnaliser",
  "request.products_not_available": "Produits non disponibles actuellement",
  "request.product_not_available": "Produit non disponible actuellement",
  "request.available-time": "Produit disponible aux horaires suivants",
  "request.item-out-of-hours": "Produit non disponible à cette heure",
  "request.available-time-from-to": "de {0} à {1}h",
  "request.product": "Produit",
  "request.products": "Produits",
  "request.creating-order": "Creation de la commande",
  "request.creating-order-title": "Nous preparons votre commande",
  "request.creating-order-description": "Nous envoyons votre commande a l'hotel. Cela ne prend que quelques secondes.",
  "request.order-created": "Commande creee",
  "request.order-created-title": "Commande creee avec succes",
  "request.order-created-description": "Votre commande a bien ete enregistree. Dans un instant, nous vous emmenons vers le detail pour la suivre.",
  "request.redirecting-to-order": "Redirection vers le detail dans",
  "request.view-order-now": "Voir la commande maintenant",
  "request.status-pending": "En attente",
  "request.confirm-cancel": "Cela annulera votre demande. Souhaitez-vous continuer ?",
  "request.only-one-for-type": "Vous ne pouvez avoir qu'une seule demande ouverte de ce type !",
  "request.lost_objects.observation": "Décrivez ici en détail les objets que vous avez perdus ainsi que le moment et le lieu où vous pourriez les avoir perdus",
  "request.generic.observation": "Si vous le souhaitez, laissez un commentaire ici.",
  "request.general.observation": "Veuillez nous dire comment nous pouvons vous aider aujourd'hui !",
  "request.car_valet.observation": "Faites-nous savoir comment nous pouvons vous aider avec votre véhicule...",
  "request.tray_collection.observation": "Des instructions spéciales pour votre collecte ?",
  "request.breakage_report.observation": "Veuillez nous informer de ce qui est cassé ou dysfonctionne",
  "request.housekeeping.observation": "Veuillez nous informer si vous avez des exigences particulières ici",
  "request.option": "Option",
  "request.observations": "Commentaires",
  "request.observations-placeholder": "Veuillez noter vos observations ; nous nous efforcerons de les suivre à la lettre.",
  "request.create.comment": "Laissez un commentaire sur votre demande",
  "request.reserved-days": "Jours Réservés",
  "notifications.enable": "Activer les notifications",
  "notifications.not_now": "Pas maintenant",
  "notifications.accept": "<b>Important:</b> Veuillez activer les notifications afin de recevoir des mises à jour en temps réel sur vos demandes !",
  "notifications.accepted": "<b class=\"text-success\">Notifications activées !</b> Vous recevrez des mises à jour en temps réel sur votre processus d'enregistrement et vos demandes pendant votre séjour !",
  "notifications.blocked": "<b class=\"text-danger\">Notifications bloquées !</b> Veuillez autoriser les notifications afin que nous puissions vous envoyer des mises à jour importantes sur vos demandes ! Cliquez sur l'icône de cadenas dans la barre d'adresse de votre navigateur. Cliquez pour activer le commutateur de notifications. Merci !",
  "notifications.confirm-continue": "<b>Êtes-vous sûr de vouloir continuer ?</b> Les notifications amélioreront votre expérience globale lors de votre séjour chez nous !",
  "notifications.empty-title": "Vous n'avez pas encore de notifications !",
  "notifications.empty-text": "Quand vous en recevrez une, elle apparaîtra ici.",
  "notificacions.title": "Notifications",
  "notifications.link.make-the-review": "Faire une évaluation",
  "stay.add-device-use-qr": "Utilisez le QR d'un autre appareil pour l'ajouter à votre séjour.",
  "yup.required": "Champ obligatoire",
  "yup.only-letters": "Seules les lettres sont autorisées",
  "yup.only-numbers": "Seuls les chiffres sont autorisés",
  "yup.only-numbers-and-letters": "Uniquement des chiffres et des lettres",
  "yup.minimal-6-digits": "Doit contenir au moins 6 chiffres",
  "yup.minimal-7-digits": "Doit contenir au moins 7 chiffres",
  "yup.minimal-2-letters": "Doit contenir au moins 2 lettres",
  "yup.maximal-50-letters": "Ne doit pas contenir plus de 50 lettres",
  "yup.maximal-12-digits": "Ne doit pas contenir plus de 12 chiffres",
  "yup.maximal-25-digits": "Ne doit pas contenir plus de 25 chiffres",
  "yup.wrong-date": "Date incorrecte",
  "yup.please-review": "Veuillez vérifier cette valeur",
  "yup.email-invalid-format": "Format d'email incorrect",
  "toast.do-not-disturb-mode-active-title": "Mode 'Ne pas déranger' actif",
  "toast.do-not-disturb-mode-active-text": "Pour faire de nouvelles demandes, vous devez d'abord désactiver le mode 'Ne pas déranger'.",
  "toast.do-not-disturb-mode-active-link": "Désactiver",

  "payments.summary-of-charges": "Résumé des frais",
  "payments.guarantee-deposit-paid": "Votre réservation dispose déjà d'un dépôt de garantie actif.",
  "payments.balance-paid": "Votre réservation n'a pas de solde impayé.",
  "payments.total-to-pay": "Total à payer",
  "payments.pay": "Aller au paiement",
  "payments.retry-pay": "Réessayer le paiement",
  "payments.items-pay-with-deposit": "Les frais à payer sont énumérés ci-dessous:",
  "payments.guarantee-deposit": "Dépôt de garantie",
  "payments.guarantee-deposit-desc": "Ce montant sera mis en attente mais ne sera pas débité de votre carte de crédit.",
  "payments.select-items-pay": "Sélectionnez les articles que vous souhaitez payer",
  "payments.payment-ok": "Votre paiement a été effectué avec succès",
  "payments.payment-error": "Une erreur s'est produite lors de la tentative de paiement",
  "payments.payment-not-authorised": "Paiement non autorisé",
  "payments.pending-confirmation": "Nous confirmons votre paiement auprès de la banque. Ne fermez pas cet écran.",
  "payments.pending-timeout": "La confirmation du paiement prend plus de temps que d'habitude. Réessayez ou contactez la réception.",
  "payments.payment-unavailable-continue": "Paiement indisponible pour le moment, vous pouvez poursuivre le web check-in et payer plus tard.",
  "payments.loading-component": "Chargement du composant de paiement...",
  "payments.later": "Je paierai plus tard",
  "payments.confirm-pay-later": "Vous confirmerez la commande et paierez plus tard. Utilisez le bouton Acheter ci-dessous.",
  "payments.back-to-pay-later": "choisir de payer plus tard",
  "payments.later-sancarlo": "Payer en espèces à la réception. Veuillez noter que notre réception est ouverte de 9h00 à 18h00. Si vous arrivez après 18h00, cette option ne sera pas disponible.",
  "payments.msg_guarantee": "Au Black Summit Laax, nous demandons un dépôt de garantie pour assurer un séjour sûr et agréable à tous nos clients. Ce dépôt sert de mesure de précaution pour couvrir d'éventuels dommages à la propriété, au mobilier ou aux équipements, ainsi que les frais accessoires tels qu'un nettoyage supplémentaire ou un départ tardif. Le dépôt sera libéré 7 jours après le départ, une fois que la propriété aura été inspectée et qu'aucun problème n'aura été constaté. Le remboursement sera effectué sur votre mode de paiement d'origine.",
  "payments.msg_guarantee_72hs": "Nous vous rappelons qu'une caution de {0} CHF doit être collectée obligatoirement 72 heures avant votre arrivée. Vous recevrez une notification par email pour vous le rappeler.",
  "payments.older": "Paiement précédent",

  "facilities.Carta_Belleza": "Carte des Soins",
  "spa.Carta_Tratamientos": "Carte des Massages",
  "facilities.Carta_SPA": "Carte",
  "home.chat-24-7": "Chat 24/7",
  "home.book-a-room": "Réserver une chambre",
  "home.book-an-apartment": "Réserver un appartement",

  "door.main": "Principale",
  "door.back": "Arrière",
  "room.address": "Adresse",
  "room.number": "Numéro de chambre",
  "room.floor": "Étage de la chambre",
  "apartment.address": "Adresse de l'appartement",
  "apartment.number": "Appartement",
  "apartment.floor": "Étage de l'appartement",

  "public.bookable.init": "Veuillez sélectionner le nombre de personnes et la date pour vérifier la disponibilité",
  "public.bookable.sent-text": "<b>Demande envoyée !</b> <br/>Vous serez informé une fois votre réservation traitée.",
  "public.bookable.fill-data": "Veuillez remplir les informations suivantes pour finaliser votre réservation pour la journée:",
  "public.edit-hour": "Modifier l’horaire",
  "public.input.name-and-surname": "Nom et prénom",
  "public.input.phone": "Téléphone",
  "public.input.email": "E-mail",
  "public.input.observations": "Remarques",
  "public.bookable.gala-experience": "Have you attended a Hotel Gala before?",
  "public.bookable.gala-experience.required": "Please select an option",
  "public.input.location": "Emplacement",
  "public.input.location.arena": "Parapluie de la pelouse",
  "public.input.location.piscina": "Parapluie de la piscine",
  "public.input.location.carpa": "Tente",
  "public.input.tent": "Numéro de tente",
  "public.bookable.list-empty": "Aucun service disponible pour la réservation.",
  "general.processing-request": "Traitement de la demande...",
  "public.request.status.canceled-msg": "La demande a été annulée.",
  "complete-to-web-checkin": "Enregistrement en ligne",
  "public.personal-information": "Informations personnelles",
  "public.input.number": "Numéro",
  "services.type.beach_service": "Service de plage",
  "service.type.request": "Demande",

  "services.make-your-reservation": "Faites votre réservation",  
  "services.make-your-reservation-button": "Réservez nos services",

  "public.reservation.not-found": "Détails de la réservation introuvables",
  "public.reservation.welcome": "Bonjour {0}, voici les détails de votre réservation :",
  "public.reservation.date-and-hour": "Date et heure",
  "public.reservation.people": "Personnes",
  "public.reservation.adults": "Adultes",
  "public.reservation.adult": "Adult",
  "public.reservation.children": "Enfants",
  "public.reservation.child": "Enfant",
  "public.reservation.state": "Statut",
  "public.reservation.status.remember-status": "Accepté",
  "public.request.cancel-assistance": "Annuler l'assistance",
  "public.request.cancel-request": "Annuler", 
  "public.reservation.observations": "Remarques",
  "public.dashboard.logout": "Déconnexion",
  "public.dashboard.welcome": "Bienvenue, {0}!",
  "public.dashboard.no-reservations": "Vous n'avez pas de réservations actives",
  "public.reservation.view-reservations": "Voir toutes mes réservations",
  "public.reservation.confirm": "Confirmer",
  "public.reservation.confirm_msg": "Vous pouvez confirmer votre réservation jusqu'à 72 heures avant l'heure de début.",
  "public.reservation.status.validating": "Traitement de la demande",
  "public.request.status.validating-msg": "Votre demande est en cours de traitement, nous vous enverrons un message lorsqu'elle sera prête.",
  "public.reservation.confirmated-at": "Réservation confirmée le",
  "public.request.forbidden.title": "Cette demande ne peut pas être affichée",
  "public.request.forbidden.description": "Cette demande ne correspond pas à l'utilisateur {0}. Si vous souhaitez continuer cette action, votre session actuelle sera fermée et vous serez redirigé vers la nouvelle.",
  "public.request.forbidden.button": "Retour au tableau de bord",
  "public.reservation.status.accepted": "",
  "public.reservation.status.confirmed": "Confirmé",
  "public.dashboard.requests": "Demandes",
  "public.dashboard.home": "Accueil",
  "public.dashboard.services": "Services",
  "public.dashboard.my-profile": "Mon profil",
  "public.reservation.status.accepted": "Demande acceptée",
  "public.reservation.status.canceled": "Annulé",
  "public.reservation.status.pending": "Requiert confirmation",
  "public.reservation.status.confirmed": "Confirmé",
  "public.request.confirmed": "Demande confirmée le",
  "public.request.payment-status.pay-again": "Réessayer le paiement",
  "public.request.payment-status.not-captured": "Le paiement n'a pas pu être capturé. Veuillez réessayer pour finaliser votre demande.",
  "public.dashboard.not-found": "Profil utilisateur introuvable",
  "public.dashboard.my-data": "Mes informations",
  "public.dashboard.name": "Nom complet",
  "public.dashboard.email": "E-mail",
  "public.dashboard.phone": "Téléphone",
  "public.dashboard.my-reservations": "Mes réservations",
  "public.dashboard.my-requests": "Mes demandes",
  "public.request.not-found": "Détails de la demande introuvables",
  "public.request.welcome": "Bonjour {0}, voici les détails de votre demande:",
  "public.request.date-and-hour": "Date et heure",
  "public.request.people": "Personnes",
  "public.request.passengers": "Passagers",
  "public.request.title": "Détails de la demande",
  "public.request.state": "Statut",
  "public.request.observations": "Observations",
  "public.request.additional-observations": "Observations supplémentaires",
  "public.request.view-requests": "Voir toutes mes demandes",
  "public.request.confirm-assistance": "Confirmer l'assistance",
  "public.dashboard.go-to-my-reservations": "Retour à mes réservations",
  "public.dashboard.cgbeach.public_cart": "Placer une commande",
  "menu.all": "Tous",
  "menu.search": "Rechercher dans le menu...",
  "menu.search_room_service": "Rechercher produit...",
  "menu.search_restaurant": "Rechercher dans le Restaurant...",
  "menu.category": "Catégorie {0}",
  "menu.vegetarian": "Végétarien",
  "menu.gluten_free": "Sans Gluten",
  "menu.items_not_found": "Aucun article configuré pour ce service. Veuillez consulter l'administrateur.",
  "menu.fail_laod_items": "Erreur lors du chargement des articles de service. Veuillez réessayer plus tard.",
  "menu.price_without_taxes": "Prix sans taxes nationales:",
  "no-hours.disabled.day": "Ce service ne sera pas disponible aujourd’hui.",
  "no-hours.disabled.general": "Hors des heures d'ouverture",
  "no-hours.disabled.slot": "Ce service n’est pas disponible pour le moment. Veuillez réessayer plus tard.",
  "general.invalid-dates": "Aucun tarif n’est disponible pour des périodes supérieures à {0} jours.",
  "general.selected-days": "Jours sélectionnés",
  "general.selected-day": "Jour sélectionné",
  "general.day": "Jour",
  "general.no-rates-available-for-selected-dates": "Aucun tarif n’est disponible pour les jours sélectionnés.", 
  "general.must-select-passengers": "Sélectionnez la quantité et les passagers dans au moins une catégorie de passagers.",
  "upselling.no-availability": "À l'heure actuelle, cette option n'est pas disponible pour votre séjour.",
  "general.payment-method": "Méthode de paiement",
  "general.select-passengers": "Sélectionner les passagers",
  "general.select-passenger": "Sélectionner le passager",

  "days.sunday": "Dimanche",
  "days.monday": "Lundi",
  "days.tuesday": "Mardi",
  "days.wednesday": "Mercredi",
  "days.thursday": "Jeudi",
  "days.friday": "Vendredi",
  "days.saturday": "Samedi",

  "public_cart.hours-label": "Horaires d'ouverture",
  "public_cart.no-available-hours": "Aucune heure disponible",
  "CHECKINS_FOUND_NONE_VALID": "La réservation n’est pas encore disponible pour l’enregistrement. Veuillez réessayer à la date d’arrivée",
  "CHECKINS_FOUND_MORE_THAN_ONE_VALID": "Un problème est survenu lors de la recherche de la réservation par chambre. Veuillez essayer avec le code de réservation",
  "CHECKINS_FOUND_NONE_LASTNAME_VALID": "Impossible de trouver la réservation",
  "kiosk.welcome.subtitle": "Check-in complété avec succès",
  "general.identify-screen.subtitle-2": "Veuillez compléter les informations suivantes pour continuer",
  "kiosk.room": "Chambre",
  "kiosk.checkin": "Check-in",
  "kiosk.checkout": "Check-out",
  "kiosk.download_app": "Scannez pour accéder à vos services de l'hôtel",
  "kiosk.scan_qr": "Scannez le code QR pour accéder à des services supplémentaires",
  "kiosk.generating_qr": "Génération du code QR...",
  "kiosk.redirect_warning": "Nous vous redirigeons dans {seconds} secondes...",
  "kiosk.go_to_identify": "Finaliser",
  "checkin.document-info": "Informations du Document",
  "checkin.personal-info": "Informations Personnelles",
  "checkin.location": "Emplacement",
  "kiosk.back": "Retour",
  "kiosk.logout.title": "Déconnexion du mode Kiosk",
  "kiosk.login.title": "Entrez votre PIN",
  "kiosk.login.description": "Veuillez entrer le code d'accès pour continuer",
  "kiosk.login.button_access": "Accès",
  "kiosk.login.button_loading": "Chargement...",
  "kiosk.login.error_empty": "Veuillez entrer le PIN",
  "kiosk.login.error_invalid": "PIN invalide. Réessayez.",
  "kiosk.login.error_process": "Erreur lors de la connexion. Réessayez.",
  "kiosk.login.copyright": "© {year} {hotel}. Tous les droits sont réservés.",
  "kiosk.login.pin": "Entrez le PIN",
  "kiosk.logout.confirm": "Entrez votre PIN pour vous déconnecter du mode Kiosk",
  "kiosk.receiving-info": "Réception des informations...",
  "kiosk.inactivity-warning-title": "Êtes-vous toujours là?",
  "kiosk.inactivity-warning-message": "Vous avez été inactif. Si vous ne répondez pas dans les prochaines secondes, votre session se terminera automatiquement.",
  "kiosk.inactivity-countdown": "La session se fermera dans",
  "kiosk.inactivity-stay": "Oui, continuer",
  "kiosk.inactivity-logout": "Non, déconnexion"
};